import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Security',
      description: '256-bit SSL encryption protects your data'
    },
    {
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'Multi-factor authentication available'
    },
    {
      icon: 'CheckCircle',
      title: 'FINRA Compliant',
      description: 'Regulated financial data provider'
    },
    {
      icon: 'Users',
      title: 'Trusted by 50K+ Investors',
      description: 'Join thousands of successful traders'
    }
  ];

  const securityBadges = [
    {
      name: 'SSL Secured',
      icon: 'Shield',
      color: 'text-success'
    },
    {
      name: 'Data Encrypted',
      icon: 'Lock',
      color: 'text-primary'
    },
    {
      name: 'GDPR Compliant',
      icon: 'CheckCircle',
      color: 'text-secondary'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Badges */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {securityBadges.map((badge, index) => (
          <div
            key={index}
            className="flex items-center space-x-2 bg-muted/50 px-3 py-2 rounded-full"
          >
            <Icon name={badge.icon} size={16} className={badge.color} />
            <span className="text-xs font-medium text-muted-foreground">
              {badge.name}
            </span>
          </div>
        ))}
      </div>

      {/* Trust Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {trustFeatures.map((feature, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-muted/30 rounded-lg"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature.icon} size={20} className="text-primary" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-1">
                {feature.title}
              </h3>
              <p className="text-xs text-muted-foreground">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Security Notice */}
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-accent mt-0.5" />
          <div>
            <p className="text-sm text-accent-foreground">
              <strong>Your Security Matters:</strong> We use industry-standard encryption 
              and never store your passwords in plain text. Your financial data is protected 
              with the same security measures used by major banks.
            </p>
          </div>
        </div>
      </div>

      {/* Last Updated */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          Security protocols last updated: July 2025
        </p>
      </div>
    </div>
  );
};

export default TrustSignals;